import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyDW3VPN2UDSVTN26WXA1GzEdFfLERKg58M',
  authDomain: 'like-hell-it-is.firebaseapp.com',
  databaseURL: 'https://like-hell-it-is.firebaseio.com',
  projectId: 'like-hell-it-is',
  storageBucket: 'like-hell-it-is.appspot.com',
  messagingSenderId: '336657953079'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

const firebaseFunctions = getFunctions(app)
// Initialize Firebase services
export const auth = getAuth(app)
export const db = getDatabase(app)
export const functions = {
  userViewedPost: httpsCallable(firebaseFunctions, 'userViewedPostV2'),
  getPostUserScores: httpsCallable(firebaseFunctions, 'getPostUserScoresV2')
}
export const storage = getStorage(app)

export default app
